import React, { useEffect } from "react";
import {
    Form,
    Input,
    InputNumber,
    Modal,
    Switch,
    Row,
    Col,
} from "antd";

const CategoryForm = ({ visible, onCreate, onCancel, record }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible) {
            if (record) {
                form.setFieldsValue({
                    name: record.name,
                    ordinal: record.ordinal ?? null,
                    isForAll: record.isForAll ?? false,
                });
            } else {
                form.resetFields();
            }
        }
    }, [visible, record, form]);

    const handleOk = () => {
        form
            .validateFields()
            .then((values) => {
                onCreate(values);
            })
            .catch((info) => {
                console.log("Validate Failed:", info);
            });
    };

    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    return (
        <Modal
            open={visible}
            title={record ? "Update Category" : "Add Category"}
            okText="Submit"
            cancelText="Cancel"
            onCancel={handleCancel}
            onOk={handleOk}
            width={800}
            zIndex={99999}
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                name="category_form"
                initialValues={{ isForAll: false }}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="name"
                            label="Name"
                            rules={[
                                { required: true, message: "Name is required" },
                                { type: "string", message: "Name should be a string" },
                            ]}
                        >
                            <Input placeholder="Enter category name" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            name="ordinal"
                            label="Ordinal"
                            rules={[
                                { type: "number", message: "Ordinal should be a number" },
                            ]}
                        >
                            <InputNumber
                                placeholder="Enter ordinal (optional)"
                                style={{ width: "100%" }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    {!record && (
                        <Col span={12}>
                            <Form.Item
                                name="isForAll"
                                label="Add For All"
                                valuePropName="checked"
                            >
                                <Switch />
                            </Form.Item>
                        </Col>
                    )}
                </Row>
            </Form>
        </Modal>
    );
};

export default CategoryForm;